<template>
  <div class="page">
    <Header title="子账号管理" :show-back="true"></Header>
    <van-search class="search" v-model="queryParam.queryName" show-action placeholder="请输入子账号名称搜索">
      <template #action>
        <div class="search-btn" @click="querySubordinateList">搜索</div>
      </template>
    </van-search>
    <PullRefresh :refreshLoading="refreshLoading" @refresh="querySubordinateList">
      <van-list v-model="pullingUploading" :finished="finished" :error.sync="error" error-text="请求失败，点击重新加载" finished-text="没有更多了" @load="onPullingUp('pulling-up')" :immediate-check="false">
        <div class="subordinate" v-for="(item, index) in subordinateList" :key="item.clientId">
          <!-- <div class="subordinate-check">
            <van-checkbox checked-color="#cd1231" v-model="item.checked" @change="clientSelected($event, index)"></van-checkbox>
          </div> -->
          <div class="subordinate-content">
            <div class="subordinate-info">
              <span><b>名称：</b>{{ item.clientName }}</span>
              <span><b>编码：</b>{{ item.clientCode }}</span>
            </div>
            <div class="subordinate-info">
              <span><b>姓名：</b>{{ item.contactPerson }}</span>
              <span><b>电话：</b>{{ item.contactMobile }}</span>
            </div>
            <div class="subordinate-point">
              <div v-for="subItem in item.pointList" :key="subItem.pointId">
                <span><b>{{ subItem.pointTypeName }}：</b>{{ subItem.pointValue }}</span>
              </div>
              <span><b>特殊积分：</b>{{ getSpecialPoint(item) }}</span>
            </div>
            <!-- <div class="subordinate-info">
              <span>允许下单</span>
              <span>{{ item.pointConsumeLimit === 1 ? '否' : '是' }}</span>
            </div> -->
          </div>
          <div class="subordinate-operate">
            <div class="subordinate-check">
              <van-checkbox checked-color="#cd1231" v-model="item.checked" @change="clientSelected($event, index)"></van-checkbox>
              <div> 积分操作：</div>
            </div>
            <div @click="handleTransferPoints('single', 'in', item.clientId)">
              <span>转入</span>
            </div>
            <div @click="handleTransferPoints('single', 'out', item.clientId)">
              <span>转出</span>
            </div>
            <div v-if="item.pointConsumeLimit === 0" @click="handleCosnumePoint('single', 'limit', item.clientId)">
              <span>限制消费</span>
            </div>
            <div v-else @click="handleCosnumePoint('single', 'enable', item.clientId)">
              <span>允许消费</span>
            </div>
            <div class="triangle-wrapper">
              <div class="triangle-icon" :style="item.pointConsumeLimit === 0 ? 'background-color: #117281': ''">{{ item.pointConsumeLimit === 1 ? '不可下单' : '可下单' }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </PullRefresh>
    <div class="bulk-operate">
      <van-checkbox class="bulk-check" checked-color="#cd1231" v-model="checkedBatch" @change="toggleClientSelected()">全选</van-checkbox>
      <div class="bulk-operate-group">
        <span @click="handleTransferPoints('batch', 'in')">转入积分</span>
        <span @click="handleTransferPoints('batch', 'out')">转出积分</span>
        <span @click="handleCosnumePoint('batch', 'limit')">限制消费</span>
        <span @click="handleCosnumePoint('batch', 'enable')">允许消费</span>
      </div>
    </div>

    <van-action-sheet class="sheet" v-model="showTransferInPointsSheet" title="转入积分至主账号" @close="handleCloseSheet">
      <van-cell center title="易加积分数量: ">
        <template #right-icon>
          <van-stepper v-model="transferInPayload.transferPointList[0].pointValue" integer min="0" input-width="80px"/>
        </template>
      </van-cell>
      <!-- <van-cell center title="特殊积分数量: ">
        <template #right-icon>
          <van-stepper v-model="transferPointsPayload.transferPointList[1].pointValue" integer input-width="80px"/>
        </template>
      </van-cell> -->
      <van-cell center title="POS积分数量: ">
        <template #right-icon>
          <van-stepper v-model="transferInPayload.transferPointList[1].pointValue" integer min="0" input-width="80px"/>
        </template>
      </van-cell>
      <van-cell center>
        <template #title>
          <span>优先转出 <b style="color:#117281">{{ specialFirst ? '特殊 ' : '易加 ' }}</b>积分</span>
        </template>
        <template #right-icon>
          <van-switch v-model="specialFirst" size="22" active-color="#117281"/>
        </template>
      </van-cell>
      <div class="sheet-btn">
        <van-button size="small" type="info" color="#117281" :disabled="btnDisabled" :loading="btnDisabled" @click="confirmTransferPoints('in')">确认转入</van-button>
      </div>
    </van-action-sheet>

    <van-action-sheet class="sheet" v-model="showTransferOutPointsSheet" title="转出积分至子账号" @close="handleCloseSheet">
      <van-cell center title="易加积分数量: ">
        <template #right-icon>
          <van-stepper v-model="transferOutPayload.transferPointList[0].pointValue" integer min="0" input-width="80px"/>
        </template>
      </van-cell>
      <van-cell center title="特殊积分数量: ">
        <template #right-icon>
          <van-stepper v-model="transferOutPayload.transferPointList[0].specialPoint" integer min="0" input-width="80px"/>
        </template>
      </van-cell>
      <van-cell center title="POS积分数量: ">
        <template #right-icon>
          <van-stepper v-model="transferOutPayload.transferPointList[1].pointValue" integer min="0" input-width="80px"/>
        </template>
      </van-cell>
      <div class="sheet-btn">
        <van-button size="small" type="info" color="#117281" :disabled="btnDisabled" :loading="btnDisabled" @click="confirmTransferPoints('out')">确认转出</van-button>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Header from '@/components/header'
import PullRefresh from '@/components/pull-refresh'
import subordinateApi from '@/api/subordinate'
// import { commonUtils } from '@/utils/common'
export default {
  name: 'SubordinateList',
  components: {
    Header,
    PullRefresh
  },
  data () {
    return {
      subordinateList: [],
      selectedSubordinateList: [],
      queryParam: {
        page: 1,
        pageSize: 10,
        queryName: ''
      },
      pageInfo: {
        totalPages: 1
      },
      transferInPayload: {
        subClientIds: [],
        transferPointList: [
          { pointType: '1', pointValue: 0 },
          { pointType: '2', pointValue: 0 }
        ],
        specialFirst: '0'
      },
      transferOutPayload: {
        subClientIds: [],
        transferPointList: [
          { pointType: '1', pointValue: 0, specialPoint: 0 },
          { pointType: '2', pointValue: 0 }
        ]
      },
      pointNum: 0,
      specialFirst: false,
      refreshLoading: false,
      pullingUploading: false,
      finished: false,
      error: false,
      checkedBatch: false,
      showTransferInPointsSheet: false,
      showTransferOutPointsSheet: false,
      btnDisabled: false
    }
  },
  created () {
    this.querySubordinateList()
  },
  methods: {
    clientSelected ($event, index) {
      console.log($event, index)
      // this.subordinateList[index].checked = !this.subordinateList[index].checked
    },
    getSpecialPoint (item) {
      if (item.pointList && item.pointList[0]) {
        return item.pointList[0].specialPoint
      } else {
        return 0
      }
    },
    // 批量选择
    toggleClientSelected () {
      this.subordinateList.forEach(item => {
        item.checked = this.checkedBatch
      })
    },
    // 获取子账号数据
    querySubordinateList (type) {
      // 下拉刷新
      if (type === 'pull-refresh') {
        this.refreshLoading = true
        this.queryParam = this.$options.data().queryParam
        this.finished = false
      }
      subordinateApi.querySubordinateList(this.queryParam).then((response) => {
        if (response.data.resultCode === '0') {
          if (type === 'pull-up') {
            this.subordinateList = this.subordinateList.concat(response.data.resultData.subClientList)
          } else {
            this.subordinateList = response.data.resultData.subClientList
          }
          this.pageInfo = response.data.resultData.pageInfo
          for (let i = 0; i < this.subordinateList.length; i++) {
            this.$set(this.subordinateList[i], 'checked', false)
          }
          this.refreshLoading = false
          this.pullingUploading = false
          this.checkedBatch = false
        }
      }).catch(() => {
        this.refreshLoading = false
        this.error = true
        this.pullingUploading = false
      })
    },

    // 上拉加载
    onPullingUp () {
      if (this.queryParam.page < this.pageInfo.totalPages) {
        this.queryParam.page += 1
        this.querySubordinateList('pull-up')
      } else {
        this.finished = true
      }
    },
    // 限制积分使用
    handleCosnumePoint (type, cosnumeType, id) {
      let checkResult = true
      let subClientIds = []
      // 单个限制
      if (type === 'single') {
        subClientIds.push(id)
      }
      // 批量限制
      if (type === 'batch') {
        let subordinateIdArray = []
        this.subordinateList.forEach(item => {
          if (item.checked) subordinateIdArray.push(item.clientId)
        })
        // 验证是否至少选择一个用户
        checkResult = this.verifyArrayLength(subordinateIdArray)
        subClientIds = subordinateIdArray
      }
      if (!checkResult) {
        return
      }
      // 启用消费限制（即 不可以使用积分消费）
      if (cosnumeType === 'limit') {
        subordinateApi.limitPoint(subClientIds).then((response) => {
          if (response.data.resultCode === '0') {
            this.$toast.success('积分消费限制已开启')
            this.checkedBatch = false
            this.querySubordinateList()
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      // 关闭消费限制（即 可以使用积分消费）
      if (cosnumeType === 'enable') {
        subordinateApi.enablePoint(subClientIds).then((response) => {
          if (response.data.resultCode === '0') {
            this.$toast.success('积分消费限制已关闭')
            this.checkedBatch = false
            this.querySubordinateList()
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },

    // 转入积分
    handleTransferPoints (type, transferType, id) {
      let checkResult = true
      let payload
      // 转入
      if (transferType === 'in') {
        payload = this.transferInPayload
      }
      // 转出
      if (transferType === 'out') {
        payload = this.transferOutPayload
      }
      // 单个转移
      if (type === 'single') {
        payload.subClientIds = []
        payload.subClientIds.push(id)
      }
      // 批量转移
      if (type === 'batch') {
        payload.subClientIds = []
        this.subordinateList.forEach(item => {
          if (item.checked) payload.subClientIds.push(item.clientId)
        })
        // 验证是否至少选择一个用户
        checkResult = this.verifyArrayLength(payload.subClientIds)
      }
      if (!checkResult) {
        return
      }
      if (transferType === 'in') {
        this.showTransferInPointsSheet = true
      }
      if (transferType === 'out') {
        this.showTransferOutPointsSheet = true
      }
    },
    // 确认转移积分
    confirmTransferPoints (transferType) {
      this.btnDisabled = true
      // 确认转入
      if (transferType === 'in') {
        this.transferInPayload.specialFirst = this.specialFirst ? '1' : '0'
        subordinateApi.transferInPoint(this.transferInPayload).then((response) => {
          if (response.data.resultCode === '0') {
            this.$toast.success('积分转入成功')
            this.showTransferInPointsSheet = false
            this.querySubordinateList()
          }
          this.btnDisabled = false
        }).catch((err) => {
          this.btnDisabled = false
          console.log(err)
        })
      }
      // 确认转出
      if (transferType === 'out') {
        subordinateApi.transferOutPoint(this.transferOutPayload).then((response) => {
          if (response.data.resultCode === '0') {
            this.$toast.success(response.data.resultMsg)
            this.showTransferOutPointsSheet = false
            this.querySubordinateList()
          }
          this.btnDisabled = false
        }).catch((err) => {
          this.btnDisabled = false
          console.log(err)
        })
      }
    },

    // 长度验证
    verifyArrayLength (subordinateIdArray) {
      console.log(subordinateIdArray)
      if (subordinateIdArray.length > 0) {
        return true
      } else {
        this.$toast({
          duration: 2000,
          message: '请至少选择一个用户'
        })
      }
    },
    handleCloseSheet () {
      this.transferInPayload = this.$options.data().transferInPayload
      this.transferOutPayload = this.$options.data().transferOutPayload
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 100px;
  padding-bottom: 70px;
}
.search {
  position: fixed;
  top: 46px;
  left: 0;
  right: 0;
  z-index: 10;
  .search-btn {
    color: #117281;
    font-weight: 600;
  }
}
.subordinate {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 10px;
  min-height: 90px;
  line-height: 20px;
  background-color: #fff;

  .subordinate-content {
    width: 100%;
    padding: 10px;
    font-size: 12px;
    word-break: break-word;
    .subordinate-info {
      display: flex;
      justify-content: space-between;
      line-height: 25px;
      span:nth-child(1) {
        width: 50%;
      }
    }
    .subordinate-point {
      display: flex;
      justify-content: space-between;
    }
  }
  .subordinate-operate {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    padding-left: 5px;
    line-height: 50px;
    color: #117281;
    font-size: 14px;
    font-weight: 600;
    border-top: 1px solid #ccc;
    .subordinate-check {
      display: flex;
      justify-content: space-around;
      background-color: #fff;
      padding-right: 40px;
      div {
        padding-right: 10px;
      }
    }
    span {
      vertical-align: middle
    }
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle
    }
    .triangle-wrapper {
      position: relative;
      overflow: hidden;
      height: 100%;
      width: 60px;
      .triangle-icon {
        position: absolute;
        right: -3px;
        top: -4px;
        height: 22px;
        width: 85px;
        font-size: 10px;
        font-weight: normal;
        line-height: 22px;
        color: #fff;
        background-color: #909399;
        text-align: center;
        transform-origin: right top;
        transform: rotate(-41deg);
      }
    }
  }
}
.bulk-operate {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  padding: 10px;
  line-height: 50px;
  background-color: #fff;
  .bulk-operate-group {
    display: flex;
    justify-content: flex-end;
    width: 80%;
    span {
      padding-right: 10px;
      color: #117281;
    }
  }
}
.sheet {
  // min-height: 300px;
  .sheet-btn {
    display: flex;
    justify-content: flex-end;
    padding: 15px;
    button:nth-child(1) {
      margin-right: 20px;
    }
  }
}
</style>
